import { render } from "./OnlineBooking.vue?vue&type=template&id=e8ce42e0&scoped=true"
import script from "./OnlineBooking.vue?vue&type=script&lang=js"
export * from "./OnlineBooking.vue?vue&type=script&lang=js"

import "./OnlineBooking.vue?vue&type=style&index=0&id=e8ce42e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8ce42e0"]])

export default __exports__